module.exports = __webpack_public_path__ + "assets/5703cdbe616cbacc4fa104092e686df6.png";